import React, { useEffect, useRef } from 'react'

import "./style.css"

const OTPInput = ({ length = 6, setValue, value, className }) => {
    const inputs = useRef([]);

    const handleChange = (e, index) => {
        const inputValue = e.target.value;
        if (!inputValue.match(/^\d?$/)) return;
        const newOtp = [...value];
        newOtp[index] = inputValue;
        setValue(newOtp);
        if (inputValue && index < length - 1) {
            inputs.current[index + 1]?.focus();
        }

        if (inputValue === '' && index > 0) {
            inputs.current[index - 1]?.focus();
        }
    }

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !value[index] && index > 0) {
            inputs.current[index - 1]?.focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, length);
        if (!pastedData) return;
        const newOtp = [...value];
        pastedData.split("").forEach((digit, index) => {
            newOtp[index] = digit;
        });

        setValue(newOtp);

        const nextIndex = Math.min(pastedData.length, length - 1);
        inputs.current[nextIndex]?.focus();
    };

    useEffect(() => {
        inputs.current[0]?.focus();
    }, []);

    return (
        <div className="otp-container">
            {value.map((digit, index) => (
                <input
                    key={index}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    ref={(el) => (inputs.current[index] = el)}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={digit}
                    onPaste={handlePaste}
                    className={`${className} otp-input`}
                />
            ))}
        </div>
    )
}

export default OTPInput
